import { render, staticRenderFns } from "./editTimeoff.vue?vue&type=template&id=5f6d4fd4&scoped=true"
import script from "./editTimeoff.vue?vue&type=script&lang=js"
export * from "./editTimeoff.vue?vue&type=script&lang=js"
import style0 from "./editTimeoff.vue?vue&type=style&index=0&id=5f6d4fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d4fd4",
  null
  
)

export default component.exports